<form class="lv-artefact-container lv-component"
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-artefact" [ngClass]="uiArtefakt.BreiteInPixel">
    <lv-label-tooltip [label]="uiArtefakt.Text" [labelSymbol]="nestedSymbol"
                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                      [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                      [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                      (infotextCollapsableChange)="infotextCollapsableChange($event)"></lv-label-tooltip>
    <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                      [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"></lv-info-text-tooltip-collapsable>
    <lv-material-form-input lvVermittlernummerValidator [hint]="uiArtefakt.Hinweis"
                            [meldung]="uiArtefakt.UIMeldung | meldung: 'Fehler': true "
                            [placeholder]="''"
                            [ngModel]="model"
                            (ngModelChange)="changeValue($event, vmr?.valid)"
                            (blur)="onBlur()"
                            [maxlength]="uiArtefakt.AnzahlZeichenMaximum"
                            [minlength]="uiArtefakt.AnzahlZeichenMinimum"
                            #vmr="ngModel" [name]="uiArtefakt.Identifikator"
                            [outerErrors]="vmr?.errors" [isTouched]="vmr?.touched"
                            [required]="uiArtefakt.PflichtfeldJN" [isDirty]="vmr?.dirty"
                            [textForRequiredError]="uiArtefakt.FehlertextPflichtfeld"
                            [disabled]="isDisabled" [errorPath]="'VMR'"
                            [autocomplete]="autocomplete">
    </lv-material-form-input>

    <lv-infotext-permanent
        [InfoTextPermanent]="uiArtefakt.InfoTextPermanent"></lv-infotext-permanent>
    <div *ngIf="darfVermittlernameSehen">{{(vermittlernummerPruefung$ | async)}}</div>

  </div>
</form>
